import { render, staticRenderFns } from "./videoRoomobs.vue?vue&type=template&id=91e05870&scoped=true"
import script from "./videoRoomobs.vue?vue&type=script&lang=js"
export * from "./videoRoomobs.vue?vue&type=script&lang=js"
import style0 from "./videoRoomobs.vue?vue&type=style&index=0&id=91e05870&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e05870",
  null
  
)

export default component.exports